/* eslint-disable max-len */
/* eslint-env browser */

/**
 * Module dependencies
 */
const React = require('react');
const Page = require('nordic/page');
const Script = require('nordic/script');

const { useI18n } = require('nordic/i18n');
const HeadView = require('../../../components/HeadView');
const HeaderView = require('../../../components/HeaderView');
const Footer = require('../../../components/FooterView');
const TwoColumn = require('../../../components/TwoColumn');
const OneColumn = require('../../../components/OneColumn');
const GoToTop = require('../../../components/GoToTop');
const NotCompliant = require('../../../components/Kyc/NotCompliant');

/**
 * ContentView Component
 */
const ContentView = (props) => {
  const {
    headerParams,
    siteId,
    user,
    refererURL,
    deviceType,
    page,
    template,
    categories,
    sideCategories,
    location,
    userPreferences,
    userLogged,
    userIsCompliant,
    kycUrl,
    backofficeOnly,
    queryParams,
    texts,
  } = props;

  const { i18n } = useI18n();

  const RenderTemplate = (() => {
    if (template === 'one_column') {
      return <OneColumn page={page} queryParams={queryParams} siteId={siteId} />;
    }
    return <TwoColumn page={page} queryParams={queryParams} sideCategories={sideCategories} location={location} deviceType={deviceType} siteId={siteId} />;
  });


  return (
    <Page name="content" state={props}>
      <HeadView i18n={i18n} location={location} title={page.title} description={page.excerpt} />
      <HeaderView i18n={i18n} {...headerParams} user={user} refererURL={refererURL} siteId={siteId} categories={categories} location={location} userPreferences={userPreferences} userLogged={userLogged} userIsCompliant={userIsCompliant} />
      {userIsCompliant ? (
        <>
          <RenderTemplate />
          <GoToTop />
          <Footer i18n={i18n} user={user} refererURL={refererURL} siteId={siteId} location={location} userLogged={userLogged} />
        </>
      ) : (
        <NotCompliant
          i18n={i18n}
          kycUrl={kycUrl}
          location={location}
          siteId={siteId}
          deviceType={deviceType}
          backofficeOnly={backofficeOnly}
          texts={texts}
        />
      )}
      <Script src="prism.js" />
      <Script src="vendor.js" />
    </Page>
  );
};

module.exports = props => <ContentView {...props} />;
